import { PluginKey } from '@tiptap/pm/state'

export const MentionPluginKey = new PluginKey('mention')
export const MENTION_SUGGESTION_POPUP_ATTR = 'data-mention-suggestion-popup'

export const hasVisibleMentionSuggestionPopup = (document: Document): boolean =>
    Array.from(document.querySelectorAll(`[${MENTION_SUGGESTION_POPUP_ATTR}="true"]`)).some(
        element => {
            const tippyBox = element
                .closest('[data-tippy-root]')
                ?.querySelector('.tippy-box[data-state="visible"]')
            return !!tippyBox
        },
    )
